import { createApp } from 'vue';
import App from './App.vue';

// `?inline` returns the CSS as a string at build time instead of emitting a
// separate .css file. We then inject it ourselves so the embed snippet stays a
// single <script> tag — no second <link> required on the host page.
import styles from './style.css?inline';

const injectStyles = () => {
    if (document.getElementById('mci-app-signup-styles')) return;
    const tag = document.createElement('style');
    tag.id = 'mci-app-signup-styles';
    tag.textContent = styles;
    document.head.appendChild(tag);
};

const node = document.querySelector('.rabbit-idx-node-signup');

if (node) {
    injectStyles();

    const app = createApp(App);
    app.provide('node', node);
    app.mount(node);
}
